import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db, firebase } from "firebase/fbConfig.js"
import moment from "moment";
import DatePicker from 'react-date-picker'

// react component for creating dynamic tables
import ReactTable from "react-table";
import { simpleTableObject } from "components/Table/createReactTableObject.jsx"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.jsx";
import {
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  TextField
} from '@material-ui/core';

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Favorite from "@material-ui/icons/Favorite";
import Check from '@material-ui/icons/Check';
import Close from "@material-ui/icons/Close";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import ProfilePicUpload from "components/CustomUpload/profilePicUpload"
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Table from "components/Table/Table.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import PrototypeExplore from "views/Explore/PrototypeExploreAssignUser"

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import Style from "assets/jss/material-dashboard-pro-react/views/profileStyle";
import Autocomplete from "@material-ui/lab/Autocomplete";

// Forms
import VendorProfileForm from "components/Forms/vendorProfileForm.jsx"
import JobApplicationForm from "components/Forms/JobApplicationForm.jsx"
import TaskCreator from "components/Forms/TaskCreatorForm.jsx"

// Assets
import DefaultProfile from "assets/img/default-avatar.png"

// Firebase Redux Integration
import { tableToFirestoreObjects, updateFirestoreWithOneObject, updateFirestoreWithTableData, addFieldToDocument } from "store/actions/firestoreActions"
import { startSetActionsList, startToggleCompleted, setUserScore } from "store/actions/actionsActions"
import { startSetVendorsList } from "../../store/actions/vendorsActions"
import CreateTruckForm from "../../components/Forms/CreateTruckForm";
import CreateTrailerForm from "../../components/Forms/CreateTrailerForm";
import AssociatePersonForm from "../../components/Forms/AssociatePersonForm";
import ShipperProfileForm from "../../components/Forms/shipperProfileForm";
import Financials from "components/Financials";
import TaskViewer from 'components/Tasks/TaskViewer.jsx';

// Table Data
import columns from 'tables/columns/orders.json';
import { getOrders, formatTableOrders } from 'tables/rows/orders';
import AddNewNoteForm from "../../components/Forms/addNewNoteForm";

const Transition = (props) => {
  return <Slide direction="down" {...props} />
}

class Orders extends React.Component {
  constructor(props) {
    super(props);

    this.dateOptions = [
      {
        label: 'Pick Up Date',
        value: 'pickUpDate',
      },
      {
        label: 'Drop Off Date',
        value: 'dropOffDate',
      },
      {
        label: 'Created At',
        value: 'updatedAt',
      }
    ];

    this.state = {
      dataLoaded: false,
      truckDataLoaded: false,
      trailerDataLoaded: false,
      userDataLoaded: false,
      updateProfileModal: false,
      updatePhotoModal: false,
      orderData: [],
      filteredOrders: null,
      revenue: null,
      expenses: null,
      contribution: null,
      contributionPercent: null,
      activeStatuses: [],
      statuses: [],
      dateOption: this.dateOptions[0].value,
      startDate: null,
      endDate: null,
      truckColumns: [
        {
          Header: "DETAILS",
          accessor: "id",
          Cell: ({ value }) => (<Link to={`${this.props.id}/truck/${value}`}><button>Details</button></Link>),
          sortable: false,
          filterable: false
        },
        {
          Header: "INTERNAL ID",
          accessor: "internalID"
        },
        {
          Header: "TYPE",
          accessor: "truckType"
        },
        {
          Header: "MAKE",
          accessor: "make"
        },
        {
          Header: "DRIVER",
          accessor: "driverName"
        },
        {
          Header: "TRAILER",
          accessor: "trailerID"
        }
      ],
      trailerColumns: [
        {
          Header: "DETAILS",
          accessor: "id",
          Cell: ({ value }) => (<Link to={`${this.props.id}/trailer/${value}`}><button>Details</button></Link>),
          sortable: false,
          filterable: false
        },
        {
          Header: "INTERNAL ID",
          accessor: "internalID"
        },
        {
          Header: "TYPE",
          accessor: "trailerType"
        },
        {
          Header: "FEET",
          accessor: "feet"
        },
        {
          Header: "DRIVER",
          accessor: "driverName"
        },
        {
          Header: "TRUCK",
          accessor: "truckID"
        }
      ],
      userColumns: [
        {
          Header: "DETAILS",
          accessor: "id",
          Cell: ({ value }) => (<Link to={`/user/${value}`}><button>Details</button></Link>),
          sortable: false,
          filterable: false
        },
        {
          Header: "NAME",
          accessor: "name"
        },
        {
          Header: "ROLE",
          accessor: "role"
        },
        {
          Header: "REMOVE",
          accessor: "id",
          Cell: ({ value }) => (<Button color="primary" onClick={() => this.removeUser(value)}
          >REMOVE</Button>),
          sortable: false,
          filterable: false
        },
      ],
      groupsColumns: [
        {
          Header: "DETAILS",
          accessor: "id",
          Cell: ({ value }) => (<Link to={`/groups/${value}`}><button>Details</button></Link>),
          sortable: false,
          filterable: false
        },
        {
          Header: "NAME",
          accessor: "name"
        }
        // {
        //   Header: "REMOVE",
        //   accessor: "id",
        //   Cell: ({ value }) => (<Button color="primary" onClick={() => this.removeUser(value)}
        //   >REMOVE</Button>),
        //   sortable: false,
        //   filterable: false
        // },
      ]
    };
  }

  assignVendor = (doc) => {
    console.log(doc);
    this.setState({ assignedVendor: doc }, () => console.log(this.state));
  }

  saveVendor = () => {
    this.state.assignedVendor && db.collection('haney-shippers').doc(this.props.id).set({
      vendorID: this.state.assignedVendor.id,
      vendorName: this.state.assignedVendor.name
    }, { merge: true })
      .then(() => window.location.reload());
  }

  removeUser = (uid) => {
    console.log(uid)
    let deleteDoc = db.collection(`haney-shippers`).doc(this.props.id).collection("users").doc(uid).delete().then(() => {
      db.collection("TEST-users").doc(uid).collection("haney-entities").doc(this.props.id).delete()
    }).then(() => {
      db.collection("TEST-users").doc(uid).collection(`haney-shippers`).doc(this.props.id).delete()
    }).then(() => {
      window.location.reload()
    }).catch((err) => {
      return (`${err}`)
    })
  }

  removeVendor = () => {
    db.collection('haney-shippers').doc(this.props.id).set({
      vendorID: '',
      vendorName: ''
    }, { merge: true })
      .then(() => {
        window.location.reload();
      })
  }

  handleClickOpen = (modal) => {
    var x = [];
    x[modal] = true;
    this.setState({
      ...x,
    });
  }

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  handleDateChange = (date, key) => {
    this.setState({ [key]: date }, this.filterOrders);
  }

  handleDateOptionChange = (e) => {
    this.setState({ dateOption: e.target.value }, this.filterOrders);
  }

  update = () => this.setState({ activeStatuses: this.activeStatuses() });

  loadData = () => {
    this.setState({
      vendors: simpleTableObject(this.props.vendors),
      dataLoaded: true
    })
  }

  selectFilters = (e, newValues) => {
    this.setState({ statuses: newValues }, this.filterOrders);
  }

  filterOrders = () => {
    if (!this.state.statuses.length && !(this.state.startDate || this.state.endDate)) return this.setState({ filteredOrders: null }, () => this.setState({ activeStatuses: this.activeStatuses() }));
    const statusFilters = this.state.statuses.map(filter => filter.toLowerCase());

    const orders = (this.state.allOrders ? this.state.allOrders : this.state.orderData).filter(order => {
      if (statusFilters.length && !statusFilters.includes(order.status.toLowerCase())) return false;

      if ((!(this.state.startDate || this.state.endDate)) && order[this.state.dateOption].split('/').length !== 3) return false;

      const toJSDate = (strDate) => {
        let [month, day, yearTime] = strDate.split('/');
        const [year, time] = yearTime.split(' ');
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
      }

      const chosenDate = toJSDate(order[this.state.dateOption]);

      if (this.state.startDate && moment(chosenDate).isBefore(this.state.startDate)) return false;

      if (this.state.endDate && moment(chosenDate).isAfter(this.state.endDate)) return false;

      return true;
    });

    this.setState({ filteredOrders: orders });
  }

  loadVendorsData = (id) => {
    console.log("loading vendor data")
    let data = db.collection("haney-shippers").doc(id)
      .get().then((snapshot) => {
        var docData = snapshot.data()
        if (docData) {
          var docObj = {
            id: snapshot.id,
            ...docData
          }
          return (docObj)
        } else {
          return (null)
        }
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(docObj => {
        this.setState({
          data: docObj,
          dataLoaded: true
        })
      })
    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }

  loadVendorTrucksData = (id) => {
    let data = db.collection("haney-vendors").doc(id).collection("trucks")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            ...docData,
            id: doc.id,
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        this.setState({
          truckData: data,
          truckDataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }

  loadVendorTrailersData = (id) => {
    let data = db.collection("haney-vendors").doc(id).collection("trailers")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            ...docData,
            id: doc.id,
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        this.setState({
          trailerData: data,
          trailerDataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }

  loadVendorUsersData = (id) => {
    let data = db.collection("haney-shippers").doc(id).collection("users")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            ...docData,
            id: doc.id,
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        this.setState({
          userData: data,
          userDataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }

  loadVendorGroupData = (id) => {
    let data = db.collection("haney-shippers").doc(id).collection('haney-groups')
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            ...docData,
            id: doc.id,
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        this.setState({
          groupsData: data,
          groupsDataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }

  loadVendorOrderData = (id) => {
    Promise.all([
      db.collection("haney-orders").where('entityIDs', 'array-contains', id).get(),
      db.collection("haney-orders").where('shipID', '==', id).get()
    ])
      .then(snapshots => Promise.all(snapshots.map(snapshot => formatTableOrders(snapshot, undefined))))
      .then(data => {
        const uniqueOrders = [
          ...data[0],
          ...data[1].filter(order => !data[0].find(o => o.freightBillNumber === order.freightBillNumber))
        ];

        this.setState({
          orderData: uniqueOrders,
          orderDataLoaded: true
        }, () => this.setState({ activeStatuses: this.activeStatuses() }))
      })
  }

  activeStatuses = () => {
    const orders = this.tableNode && this.tableNode ? this.tableNode.state.sortedData : this.state.filteredOrders ? this.state.filteredOrders : this.state.orderData;
    return Object.keys(orders.reduce((prev, curr) => {
      if (!prev[curr.status]) prev[curr.status] = true;
      return prev;
    }, {}));
  }

  render() {
    const { AuthBool, classes, user, id } = this.props;

    let vendor = "";

    function filterCaseInsensitive(filter, row) {
      const id = filter.pivotId || filter.id;
      return row[id] !== undefined
        ? (String(row[id]).toLowerCase()).includes(filter.value.toLowerCase())
        : true;
    }

    // if (this.state.vendors) {
    //   console.log(this.state.vendors)
    //   var currentVendor = this.state.vendors.filter(function (el) {
    //     return el.vendorID == id ;
    //   });
    //   vendor = (currentVendor[0])
    // }


    if (this.state.dataLoaded) {
      vendor = this.state.data
    }

    let profilePhoto = DefaultProfile
    if (AuthBool) { // fixes freeze on logout
      if (user.dataLoaded) {
        user.profileURL ? (
          profilePhoto = user.profileURL
        ) : (
          // add link to profile photo to firestore
          profilePhoto = !!this.props.authUser.photoURL ? this.props.authUser.photoURL : DefaultProfile
          // add profile photo to firebase storage
          // update redux with link
        )
      }
    }

    if (user.dataLoaded
      && !this.state.dataLoaded) {
      this.loadVendorsData(id);
      this.loadVendorTrucksData(id);
      this.loadVendorTrailersData(id);
      this.loadVendorUsersData(id),
      this.loadVendorOrderData(id)
      this.loadVendorGroupData(id)

    }

    console.log(this.state)
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={10}>
          {this.state.dataLoaded && vendor ? (
            <GridContainer>
              <GridItem xs={12}>
                <h1 className={classes.title}>
                  SHIPPER PROFILE</h1>
              </GridItem>
              <Button
                color="primary"
                onClick={() => this.handleClickOpen("updateProfileModal")}
              >UPDATE</Button>
              <GridItem xs={12} sm={12} lg={12}>
                <h2>ADDRESSING</h2>

                <h4 className={classes.subTitle}>BUSINESS NAME:</h4>
                {vendor.name ? <p className={classes.body}>{vendor.name} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>PHYSICAL ADDRESS:</h4>
                {vendor.physicalAddress ? <p className={classes.body}>{vendor.physicalAddress} {vendor.physicalCity && vendor.physicalCity}, {vendor.physicalState && vendor.physicalState} {vendor.physicalZip && vendor.physicalZip}</p> : <p className={classes.body}>Click UPDATE to add your address</p>}
                {/* {vendor.city ? <p className={classes.body}>{vendor.city} </p> : <p className={classes.body}>Click UPDATE to add your address</p>}
                {vendor.state ? <p className={classes.body}>{vendor.state} </p> : <p className={classes.body}>Click UPDATE to add your address</p>}
                {vendor.zip ? <p className={classes.body}>{vendor.zip} </p> : <p className={classes.body}>Click UPDATE to add your address</p>} */}
                <h4 className={classes.subTitle}>MAIN PHONE:</h4>
                {vendor.mainPhone ? <p className={classes.body}>{vendor.mainPhone} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>MAIN EMAIL:</h4>
                {vendor.businessEmail ? <p className={classes.body}>{vendor.businessEmail} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}

                <h4 className={classes.subTitle}>LOCATION NOTES:</h4>
                {vendor.locationNotes ? <p className={classes.body}>{vendor.locationNotes} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>PICTURE OF BUILDING:</h4>
                {vendor.undefined ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>REMIT TO PARENT CONNECTION:</h4>
                {vendor.remit ? <p className={classes.body}>{vendor.remit} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>BUSINESS OPENS:</h4>
                {vendor.businessOpen ? <p className={classes.body}>{vendor.businessOpen} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>BUSINESS CLOSES:</h4>
                {vendor.businessClose ? <p className={classes.body}>{vendor.businessClose} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}

              </GridItem>
              <GridItem xs={12} sm={12} lg={12}>
                <h2>ACCOUNTING / REGULATORY</h2>
                <h4 className={classes.subTitle}>MAILING ADDRESS:</h4>
                {vendor.mailingAddress ? <p className={classes.body}>{vendor.mailingAddress} {vendor.mailingCity && vendor.mailingCity}, {vendor.mailingState && vendor.mailingState} {vendor.mailingZip && vendor.mailingZip} </p> : <p className={classes.body}>Click UPDATE to add your mailing address</p>}
                <h4 className={classes.subTitle}>ACCOUNTING EMAIL:</h4>
                {vendor.accountingEmail ? <p className={classes.body}>{vendor.accountingEmail} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>QUICKBOOKS ID:</h4>
                {vendor.quickbooksID ? <p className={classes.body}>{vendor.quickbooksID} </p> : <p className={classes.body}>Click UPDATE to add QB ID</p>}
                <h4 className={classes.subTitle}>ACCOUNTING NOTES:</h4>
                {vendor.accountingNotes ? <p className={classes.body}>{vendor.accountingNotes} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>CREDIT CARD INTERFACE:</h4>
                {vendor.creditCardInterface ? <p className={classes.body}>{vendor.creditCardInterface} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>CREDIT APPROVAL:</h4>
                {vendor.creditApproval ? <p className={classes.body}>{vendor.creditApproval} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>CREDIT TERMS:</h4>
                {vendor.creditTerms ? <p className={classes.body}>{vendor.creditTerms} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>CREDIT LIMIT:</h4>
                {vendor.creditLimit ? <p className={classes.body}>{vendor.creditLimit} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>DSO:</h4>
                {vendor.dso ? <p className={classes.body}>{vendor.dso} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>KSMS Status:</h4>
                {vendor.ksms ? <p className={classes.body}>{String(vendor.ksms)} </p> : <p className={classes.body}>false</p>}
                <h4 className={classes.subTitle}>KSMS ID:</h4>
                {vendor.ksmsID ? <p className={classes.body}>{vendor.ksmsID} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>KSMS ADDED DATE:</h4>
                {vendor.ksmsAddedDate ? <p className={classes.body}>{String(vendor.ksmsAddedDate.toDate())} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>CONTACTS:</h4>
                {vendor.undefined ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}

              </GridItem>
              <GridItem xs={12} sm={12} lg={12}>
                <h4 className={classes.subTitle}>ADDITIONAL SERVICES:</h4>
                {vendor.undefined ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h2>ANALYTICS</h2>

                <h4 className={classes.subTitle}>PAST SHIPMENTS:</h4>
                {vendor.undefined ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>AVERAGE SELL RATE PER SERVICE TYPE:</h4>
                {vendor.undefined ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>PAST FAILURES:</h4>
                {vendor.undefined ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>HISTORICAL PRICE TOLERANCE MATRIX:</h4>
                {vendor.undefined ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
              </GridItem>
              <GridItem xs={12} sm={12} lg={12}>
                <GridItem xs={12} sm={12} lg={12}>
                  <h2 style={{ margin: "0" }}>PERSONNEL</h2>
                  <GridContainer>
                    <GridItem xs={6}>
                      <Button
                        color="primary"
                        onClick={() => this.handleClickOpen("updatePersonModal")}
                      >ADD NEW PERSON</Button>
                    </GridItem>
                    <GridItem xs={6}>

                    </GridItem>
                  </GridContainer>
                  <ReactTable
                    data={this.state.userData}
                    filterable
                    defaultFilterMethod={filterCaseInsensitive}
                    columns={this.state.userColumns}
                    defaultPageSize={10}
                    defaultSorted={[
                      {
                      }
                    ]}
                    //showPaginationTop
                    showPaginationBottom
                    style={{
                      color: "#000"
                    }}
                    className="-striped -highlight"
                  />

                </GridItem>
                <GridItem xs={12} sm={12} lg={12}>
                  <h2 style={{ margin: "0" }}>GROUPS</h2>
                  <GridContainer>
                    <GridItem xs={6}>
                      {/* <Button
                        color="primary"
                        onClick={() => this.handleClickOpen("updateGroupsModal")}
                      >ADD NEW PERSON</Button> */}
                    </GridItem>
                    <GridItem xs={6}>

                    </GridItem>
                  </GridContainer>
                  <ReactTable
                    data={this.state.groupsData}
                    filterable
                    defaultFilterMethod={filterCaseInsensitive}
                    columns={this.state.groupsColumns}
                    defaultPageSize={10}
                    defaultSorted={[
                      {
                      }
                    ]}
                    //showPaginationTop
                    showPaginationBottom
                    style={{
                      color: "#000"
                    }}
                    className="-striped -highlight"
                  />

                </GridItem>

                <GridItem xs={12} sm={12} lg={12}>
                  <h2 style={{ margin: "0" }}>ASSOCIATE VENDOR</h2>
                  <GridContainer alignItems='center'>
                    {vendor.vendorID && (
                      <React.Fragment>
                        <GridItem>
                          Current Vendor Associated: <Link to={`/vendor/${vendor.vendorID}`}>{vendor.vendorName}</Link>
                        </GridItem>
                        <GridItem>
                          <Button
                            color="primary"
                            onClick={() => this.removeVendor()}
                          >REMOVE ASSOCIATION</Button>
                        </GridItem>
                      </React.Fragment>
                    )}
                    <GridItem xs={12}>
                      <Button
                        color="primary"
                        onClick={() => this.handleClickOpen("updateVendorModal")}
                      >ASSOCIATE NEW VENDOR</Button>
                    </GridItem>
                  </GridContainer>

                </GridItem>

                <GridItem xs={12} sm={12} lg={12}>
                  <h2 style={{ margin: "0" }}>SHIPPER TASKS</h2>
                  <TaskCreator
                    classes={this.props.classes}
                    entityID={this.props.user.shipperID}
                    profileType={"shipper"}
                    name={vendor.name}
                  />
                   <TaskViewer onProfilePage={true} entityID={this.props.user.shipperID} />
                </GridItem>
                <GridItem xs={12} sm={12} lg={12}>
                  <h2 style={{ margin: "0" }}>ORDERS</h2>
                  {this.tableNode && (
                    <Financials orders={this.tableNode} />
                  )}
                  <GridContainer justify='center'>
                    <GridItem xs={12}>
                      <GridContainer justify='center' style={{ marginBottom: '8px' }} alignItems='center'>
                        <GridItem>
                          <Select
                            value={this.state.dateOption}
                            onChange={this.handleDateOptionChange}
                            style={{ marginTop: '24px' }}
                          >
                            {this.dateOptions.map((option, i) => (
                              <MenuItem value={option.value} key={i}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </GridItem>
                        <GridItem>
                          <p style={{ textAlign: 'center' }}>Start</p>
                          <DatePicker
                            onChange={(e) => this.handleDateChange(e, 'startDate')}
                            value={this.state.startDate}
                          />
                        </GridItem>
                        <GridItem>
                          <p style={{ textAlign: 'center' }}>End</p>
                          <DatePicker
                            onChange={(e) => this.handleDateChange(e, 'endDate')}
                            value={this.state.endDate}
                          />
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                    <GridItem xs={6}>
                      <Autocomplete
                        multiple
                        options={this.state.activeStatuses}
                        getOptionLabel={(option) => option}
                        value={this.state.statuses}
                        filterSelectedOptions
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Statuses"
                            variant="outlined"
                            fullWidth
                          />
                        )}
                        onChange={this.selectFilters}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={6}>
                      <Button
                        color="primary"
                        onClick={() => this.handleClickOpen("")}
                      >ADD NEW TRANSACTION</Button>
                    </GridItem>
                    <GridItem xs={6}>

                    </GridItem>
                  </GridContainer>
                  <ReactTable
                    ref={(r) => {
                      this.tableNode = r;
                    }}
                    data={this.state.filteredOrders ? this.state.filteredOrders : this.state.orderData}
                    filterable
                    defaultFilterMethod={filterCaseInsensitive}
                    columns={columns.columns}
                    defaultPageSize={10}
                    defaultSorted={[
                      {
                        id: "freightBillNumber",
                        desc: true
                      }
                    ]}
                    onFilteredChange={this.update}
                    showPaginationBottom
                    style={{
                      color: "#000"
                    }}
                    className="-striped -highlight"
                  />

                </GridItem>


                <h2>ANALYTICS</h2>

                <h4 className={classes.subTitle}>ON TIME RATING:</h4>
                {vendor.undefined ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>FAILURE LIST:</h4>
                {vendor.undefined ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>AVERAGE PRICE PER n:</h4>
                {vendor.undefined ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>AVAILIBILITY RATING:</h4>
                {vendor.undefined ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <h4 className={classes.subTitle}>CUSTOMER/LOGISTICIAN REVIEW:</h4>
                {vendor.undefined ? <p className={classes.body}>{vendor.vendorName} </p> : <p className={classes.body}>Click UPDATE to add your name</p>}
                <Button
                  color="primary"
                  onClick={() => this.handleClickOpen("updateProfileModal")}
                >UPDATE</Button>

              </GridItem><br />
              <h2>NOTES
              </h2>
              <GridItem xs={12}>
                <AddNewNoteForm shipperID={vendor.id} />
              </GridItem>

              {/* UPDATE PROFILE MODAL */}
              <Dialog
                // classes={{
                //   root: classes.modalRoot,
                //   paper: classes.modal + " " + classes.modalSmall
                // }}
                style={{ height: "auto" }}
                open={this.state.updateProfileModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose("updateProfileModal")}
                aria-labelledby="shipment-modal-slide-title"
                aria-describedby="shipment-modal-slide-description"
              >
                <DialogTitle
                  id="shipment-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    simple
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updateProfileModal")}
                  >
                    {" "}
                    <Close className={classes.modalClose} />
                  </Button>
                  <h2 className={classes.modalTitle}>EDIT PROFILE</h2>
                </DialogTitle>
                <DialogContent
                  id="shipment-modal-slide-description"
                  className={classes.modalBody}
                >
                  {/* FORM */}
                  {/* {console.log(vendor)} */}

                  <ShipperProfileForm
                    id={id}
                    vendor={vendor}
                    modalOpen={this.state.updateProfileModal}
                  />

                  <Button
                    style={{
                      backgroundColor: "black",
                      marginLeft: "10px",
                      marginTop: "10px"
                    }}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updateProfileModal")}
                  >
                    CLOSE
                  </Button>
                </DialogContent>
              </Dialog>

              {/* UPDATE PROFILE PHOTO MODAL */}
              <Dialog
                classes={{
                  root: classes.modalRoot,
                  paper: classes.modal + " " + classes.modalSmall
                }}
                open={this.state.updatePhotoModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose("updatePhotoModal")}
                aria-labelledby="shipment-modal-slide-title"
                aria-describedby="shipment-modal-slide-description"
              >
                <DialogTitle
                  id="shipment-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    simple
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updatePhotoModal")}
                  >
                    {" "}
                    <Close className={classes.modalClose} />
                  </Button>
                  <h2 className={classes.modalTitle}>UPDATE PROFILE PHOTO</h2>
                </DialogTitle>
                <DialogContent
                  id="shipment-modal-slide-description"
                  className={classes.modalBody}
                >

                  {/* FORM */}
                  <ProfilePicUpload
                    currentPic={profilePhoto}
                    username={this.props.user.username ? this.props.user.username : null}
                    uid={this.props.authUser.uid}
                  />
                  <div
                    style={{
                      textAlign: "center"
                    }}
                  >
                    <Button
                      className={classes.ltrButtonWhite}

                      key="close"
                      aria-label="Close"
                      onClick={() => this.handleClose("updatePhotoModal")}
                    >
                      CANCEL
                    </Button>
                  </div>
                </DialogContent>
              </Dialog>

              {/* UPDATE TRUCK MODAL */}
              <Dialog
                // classes={{
                //   root: classes.modalRoot,
                //   paper: classes.modal + " " + classes.modalSmall
                // }}
                style={{ height: "auto" }}
                open={this.state.updateTrucksModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose("updateTrucksModal")}
                aria-labelledby="shipment-modal-slide-title"
                aria-describedby="shipment-modal-slide-description"
              >
                <DialogTitle
                  id="shipment-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    simple
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updateTrucksModal")}
                  >
                    {" "}
                    <Close className={classes.modalClose} />
                  </Button>
                  <h2 className={classes.modalTitle}>ADD NEW TRUCK</h2>
                </DialogTitle>
                <DialogContent
                  id="shipment-modal-slide-description"
                  className={classes.modalBody}
                >
                  {/* {console.log(id)} */}
                  {/* FORM */}
                  <CreateTruckForm
                    id={id}
                    vendor={vendor}
                    modalOpen={this.state.updateTrucksModal}
                  />

                  <Button
                    style={{
                      backgroundColor: "black",
                      marginLeft: "10px",
                      marginTop: "10px"
                    }}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updateTrucksModal")}
                  >
                    CLOSE
                  </Button>
                </DialogContent>
              </Dialog>

              {/* UPDATE TRAILER MODAL */}
              <Dialog
                // classes={{
                //   root: classes.modalRoot,
                //   paper: classes.modal + " " + classes.modalSmall
                // }}
                style={{ height: "auto" }}
                open={this.state.updateTrailersModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose("updateTrailersModal")}
                aria-labelledby="shipment-modal-slide-title"
                aria-describedby="shipment-modal-slide-description"
              >
                <DialogTitle
                  id="shipment-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    simple
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updateTrailersModal")}
                  >
                    {" "}
                    <Close className={classes.modalClose} />
                  </Button>
                  <h2 className={classes.modalTitle}>ADD NEW TRAILER</h2>
                </DialogTitle>
                <DialogContent
                  id="shipment-modal-slide-description"
                  className={classes.modalBody}
                >
                  {/* {console.log(id)} */}
                  {/* FORM */}
                  <CreateTrailerForm
                    id={id}
                    vendor={vendor}
                    modalOpen={this.state.updateTrailersModal}
                  />

                  <Button
                    style={{
                      backgroundColor: "black",
                      marginLeft: "10px",
                      marginTop: "10px"
                    }}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updateTrailersModal")}
                  >
                    CLOSE
                  </Button>
                </DialogContent>
              </Dialog>

              {/* UPDATE PERSON MODAL */}
              <Dialog
                // classes={{
                //   root: classes.modalRoot,
                //   paper: classes.modal + " " + classes.modalSmall
                // }}
                style={{ height: "auto" }}
                open={this.state.updatePersonModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose("updatePersonModal")}
                aria-labelledby="shipment-modal-slide-title"
                aria-describedby="shipment-modal-slide-description"
              >
                <DialogTitle
                  id="shipment-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    simple
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updatePersonModal")}
                  >
                    {" "}
                    <Close className={classes.modalClose} />
                  </Button>
                  <h2 className={classes.modalTitle}>ADD NEW PERSON</h2>
                </DialogTitle>
                <DialogContent
                  id="shipment-modal-slide-description"
                  className={classes.modalBody}
                >
                  {/* {console.log(id)} */}
                  {/* FORM */}
                  <AssociatePersonForm
                    id={id}
                    type={"shippers"}
                    vendor={vendor}
                    modalOpen={this.state.updatePersonModal}
                  />

                  <Button
                    style={{
                      backgroundColor: "black",
                      marginLeft: "10px",
                      marginTop: "10px"
                    }}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updatePersonModal")}
                  >
                    CLOSE
                  </Button>
                </DialogContent>
              </Dialog>

              <Dialog
                // classes={{
                //   root: classes.modalRoot,
                //   paper: classes.modal + " " + classes.modalSmall
                // }}
                style={{ height: "auto" }}
                maxWidth='sm'
                fullWidth
                open={this.state.updateVendorModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.handleClose("updateVendorModal")}
                aria-labelledby="shipment-modal-slide-title"
                aria-describedby="shipment-modal-slide-description"
              >
                <DialogTitle
                  id="shipment-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <Button
                    simple
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    onClick={() => this.handleClose("updateVendorModal")}
                  >
                    {" "}
                    <Close className={classes.modalClose} />
                  </Button>
                  <h2 className={classes.modalTitle}>Associate Vendor</h2>
                </DialogTitle>
                <DialogContent
                  id="shipment-modal-slide-description"
                  className={classes.modalBody}
                >
                  {/* {console.log(id)} */}
                  {/* FORM */}
                  <GridContainer justify='space-between'>

                    <GridItem xs={12}>
                      Vendors:
                      <PrototypeExplore
                        collection='haney-vendors'
                        assignUser={this.assignVendor}
                      />
                      {this.state.assignedVendor ? this.state.assignedVendor.name : null}
                    </GridItem>

                    <GridItem>
                      <Button
                        style={{
                          backgroundColor: "black",
                        }}
                        key="close"
                        aria-label="Close"
                        onClick={() => this.handleClose("updateVendorModal")}
                      >
                        CLOSE
                      </Button>
                    </GridItem>
                    <GridItem>
                      <Button
                        color='primary'
                        aria-label="Save"
                        onClick={() => this.saveVendor()}
                      >
                        SAVE
                      </Button>
                    </GridItem>

                  </GridContainer>


                </DialogContent>
              </Dialog>

            </GridContainer>
          ) : (
            <p className={classes.body}>Loading...</p>
          )}
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    AuthBool: !!state.auth.user,
    authUser: state.auth.user,
    user: state.profile.user,
    vendors: state.vendors.shipments,
    id: ownProps.match.params.id
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    startSetVendorsList: () => dispatch(startSetVendorsList())
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(Style)
)(Orders);



// WEBPACK FOOTER //
// ./src/views/Profile/shipperProfile.jsx